import React from 'react';
import styled from 'styled-components';
import Logo from '../../images/coti-logo.png';

const FooterContainer = styled.footer`
    background-color: #f0f0f0;
    display: flex;
    justify-content: center;
`

const InnerContainer = styled.a`
    padding-bottom: 28px;
    font-size: 12px;
    font-weight: normal;
    font-style: normal;
    font-stretch: normal;
    line-height: normal;
    letter-spacing: normal;
    text-align: center;
    text-decoration: none;
    color: #474646;
    text
    font-family: roboto, sans-serif;
    > img{
        margin-left: 10px;
        width: 36px;
    }
`

export const Footer = () => {
    return (
        <FooterContainer>
            <PoweredByCoti />
        </FooterContainer>
    )
}

export const PoweredByCoti = ({className = ""}) => {
    return (
        <InnerContainer href="https://coti.io" target="_blank" rel="noopener noreferrer" className={className}>
            Powered by
            <img src={Logo} alt="logo"/>
        </InnerContainer>
    )
}